module.exports = __webpack_public_path__ + "img/316-ee26c4.png";